import React, { useState, useEffect } from 'react'
import LoadingUI from '../../common/LoadingUI'
import { Box, Card, Grid, IconButton, Stack, Typography } from '@mui/material'
import CachedIcon from '@mui/icons-material/Cached';

import { useDispatch, useSelector } from 'react-redux';
import { totalSurveyAttemptPublisherAction } from '../../redux/toolkit/dashboard/totalSurveyAttempt'

const TotalConversionRate = () => {
    const dispatch = useDispatch();

    const dashboard = useSelector(state => state.totalSurveyAttempt)
    const { message, data, status, loading } = dashboard


    const handleMissionAttemptRefresh = async () => {
        dispatch(totalSurveyAttemptPublisherAction())
    }

    let conversion_rate = 0
    if(Number(data?.total) > 0 && Number(data?.completed) > 0){
        conversion_rate = ((data?.completed / data?.total) * 100).toFixed(2)
    }



    // useEffect
    useEffect(() => {
        dispatch(totalSurveyAttemptPublisherAction())
    }, [dispatch])
    return (
        <>
            <Card elevation={0} sx={{ p: 2, height: "116px" , borderRadius:"11px" , position:"relative", background: "rgba(254, 206, 113, 0.16)"}}>
            <Stack direction={'row'} position={"absolute"} bottom={10} left={10} justifyContent='space-between'>
                    <Typography variant='p'>Total Conversion Rate % </Typography>
                    {/* <IconButton onClick={handleMissionAttemptRefresh}><CachedIcon /></IconButton> */}
                </Stack>
                {loading
                    ? <LoadingUI justifyContent='flex-start' />
                    : <Typography  fontSize={{
                        xs: "22px",
                        sm: "30px",
                        md: "30px",
                        lg: "30px",
                        xl: "30px",
                      }} color='#071D45' fontWeight={700} variant='h4'>{conversion_rate ? conversion_rate : '--'}</Typography>}

            </Card>
        </>

    )
}

export default TotalConversionRate
